import { Icon, Tag } from '@boltenergy-be/design-system'
import styles from './NavigationItemContent.module.scss'
import classNames from 'classnames'
import { NavigationItemContentProps } from './types.ts'

const NavigationItemContent = ({ icon, text, isMore, iconClass, tag, collapsed }: NavigationItemContentProps) => (
  <>
    {Array.isArray(icon) ? (
      <div className={styles.icons}>
        {icon.map((i) => (
          <Icon key={i} name={i} className={classNames(styles.icon, iconClass)} />
        ))}
      </div>
    ) : (
      <Icon name={icon} className={classNames(styles.icon, iconClass)} />
    )}
    {!collapsed && <span className={classNames(styles['text-content'], 'truncate', { [styles.more]: isMore })}>{text}</span>}
    {tag && (
      <Tag type={tag.type} size="small" className="ml-auto">
        {tag.text}
      </Tag>
    )}
    {isMore && <Icon name="chevronRight" className={styles.chevron} />}
  </>
)

export default NavigationItemContent
